module.exports = __webpack_public_path__ + "img/public/SiteIcons/fb.svg?ad429fa0";